import { connect } from 'react-redux';
import { RootState } from 'src/store';
import { setTraceRulerColor, setTraceRulerSpacing } from '../../canvas/slice';
import TraceRulerSettings from './traceRulerSettings';

const mapStateToProps = (state: RootState) => ({
    color: state.pages.editor.canvas.traceRulerColor,
    spacing: state.pages.editor.canvas.traceRulerSpacing,
});

const TraceRulerSettingsContainer = connect(mapStateToProps, {
    setTraceRulerColor,
    setTraceRulerSpacing,
})(TraceRulerSettings);

export default TraceRulerSettingsContainer;
